// cancel-http.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CancelHttpService } from './cancelHttpSerivce.service';

@Injectable()
export class CancelHttpInterceptor implements HttpInterceptor {
  constructor(private cancelHttp: CancelHttpService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Don't cancel requests for getWhiteLabellingByURL API
    if (req.url.includes('getWhiteLabellingByURL') ||
     req.url.includes('getCurrentDate') || 
     req.url.includes('getUserDetails') || 
     req.url.includes('entityWebsiteConfig')) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      takeUntil(this.cancelHttp.onCancelAllRequests())
    );
  }
}
